import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { catchError, concatMap, switchMap, tap } from 'rxjs/operators';

import { AuthenticationService } from '../../shared/services/authentication.service';
import { DeviceUtilsService } from '../../shared/services/device-utils.service';
import * as fromParticipantsActions from '../participants/actions';
import * as fromAuthActions from './actions';
import * as fromAuthSelectors from './selectors';

@Injectable()
export class AuthEffects {
  readonly authenticate$ = createEffect(() => {
    return this.actions.pipe(
      ofType(fromAuthActions.authenticate),
      switchMap(({ initPayload }) => {
        return this.authenticationService.postInitPayload(initPayload).pipe(
          concatMap(tokenResponse => {
            return [
              fromAuthActions.authenticateSuccess(),
              fromParticipantsActions.setParticipantList({
                participants: tokenResponse.data.participants,
              }),
            ];
          }),
          catchError(err => {
            return of(
              fromAuthActions.authenticateFailure({
                error: err.message,
                initPayloadErrored: initPayload,
              }),
            );
          }),
        );
      }),
    );
  });

  readonly authenticateFailure$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(fromAuthActions.authenticateFailure),
        tap(() => this.router.navigateByUrl('/service-unavailable')),
      );
    },
    { dispatch: false },
  );

  readonly redirection$ = createEffect(
    () => {
      return combineLatest([
        this.store.select(fromAuthSelectors.isAuthenticated),
        this.deviceUtilsService.isMobile$,
      ]).pipe(
        tap(([authenticated, isMobile]) => {
          if (authenticated) {
            this.router.navigateByUrl(isMobile ? '/mobile' : '/desktop');
          } else {
            // TODO do something when user isn't authenticated?
          }
        }),
      );
    },
    { dispatch: false },
  );

  constructor(
    private readonly actions: Actions,
    private readonly store: Store,
    private readonly router: Router,
    private readonly deviceUtilsService: DeviceUtilsService,
    private readonly authenticationService: AuthenticationService,
  ) {}
}
